export default __webpack_public_path__ + "static/media/brand.c5b9d846.svg";